import { useServicesContext } from "@modules/core/services/services.context"
import { CrossFitEvent } from "@modules/crossfitEvent/entities/crossfitEventEntity"
import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"

export const useCrossfitEvents = () => {
  const { crossfitEventApi } = useServicesContext()

  const { data, isLoading } = useQuery({
    queryKey: ["events"],
    staleTime: 1000 * 60 * 60 * 24,
    queryFn: async () => {
      const crossfitEvents = await crossfitEventApi.getCrossfitEvents()

      return crossfitEvents.map((crossfitEvent) => CrossFitEvent.fromDto(crossfitEvent))
    },
  })

  const crossfitEventsMap = useMemo(
    () =>
      data?.reduce<Record<string, CrossFitEvent>>((acc, event) => {
        return {
          ...acc,
          [event.id]: event,
        }
      }, {}),
    [data],
  )

  return {
    crossfitEventsList: data,
    crossfitEventsMap,
    isLoading,
  }
}
